import type { PayMode, SaleTotals } from './types';

interface TotalsInput {
  subtotal: number;
  oldDebt: number;
  payMode: PayMode;
  /** "Qisman" rejimida kiritilgan summa (xom qiymat). */
  payAmountInput: string;
}

/**
 * Sotuv hisob-kitobi — bitta joyda.
 *
 * Eski qarz API'dan satr ("7000.00") bo'lib kelishi mumkin — `Number` ga
 * o'tkazilmasa `orderTotal + oldDebt` qo'shish emas, konkatenatsiya bo'ladi.
 */
export function computeSaleTotals({
  subtotal,
  oldDebt,
  payMode,
  payAmountInput,
}: TotalsInput): SaleTotals {
  const orderTotal = subtotal;
  const previousDebt = Number(oldDebt) || 0;
  const grandTotal = orderTotal + previousDebt;

  const paying =
    payMode === 'full'
      ? grandTotal
      : payMode === 'credit'
        ? 0
        : Math.min(parseInt(payAmountInput, 10) || 0, grandTotal);

  return {
    subtotal,
    orderTotal,
    oldDebt: previousDebt,
    grandTotal,
    paying,
    remaining: grandTotal - paying,
  };
}

/** Bugungi sana `<input type="date">` uchun. */
export function today(): string {
  return new Date().toISOString().split('T')[0];
}

export function formatUzs(value: number | string): string {
  return `${Number(value).toLocaleString('uz-UZ')} so'm`;
}

/**
 * Sana — kun.oy.yil.
 *
 * `toLocaleDateString('uz-UZ')` oyni "M09" ko'rinishida chiqaradi (brauzerlarda
 * uz-UZ uchun oy nomlari yo'q), shuning uchun chekdagi PDF bilan bir xil
 * formatni o'zimiz yasaymiz.
 */
export function formatDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}
